export { default, type RegisterFormContentProps } from './RegisterFormContent';
